export default __webpack_public_path__ + "static/media/wool_yellow.b8f593fd.jpg";